/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscriptions_eventsearch.js                                                        */
/**********************************************************************************************************************/
/* Subscriptions EventSearch */

HafasWebapp.prototype.subscriptions.EventSearch = function(_me) {

  Hafas.ps.sub('/EventSearch/postForm', Hafas.bind(_me.Controller.EventSearch.postForm,_me));
  Hafas.ps.sub("/EventSearch/toggleDetails", Hafas.bind(_me.Controller.EventSearch.toggleDetails, _me));
  Hafas.ps.sub("/EventSearch/iframeLoaded", Hafas.bind(_me.Controller.EventSearch.iframeLoaded, _me));
  Hafas.ps.sub("/EventSearch/planTrip", Hafas.bind(_me.Controller.EventSearch.planTrip, _me));
  Hafas.ps.sub("/EventSearch/centerEventOnMap", Hafas.bind(_me.Controller.EventSearch.centerEventOnMap, _me));

  Hafas.ps.sub("/eventsearch/clearInput", Hafas.bind(_me.Controller.EventSearch.clearInput, _me));

  Hafas.ps.sub('/GUI/leaveContext/EventSearch', Hafas.bind(_me.Controller.EventSearch.leaveContext,_me));

  Hafas.ps.sub('/dateTimePicker/selectDateTime/EventSearch_date', Hafas.bind(_me.Controller.EventSearch.setDate,_me));

  Hafas.ps.sub('/app/events/resize', Hafas.bind(_me.Controller.EventSearch.resize,_me));

  Hafas.ps.sub('/GUI/closeView/EventSearch', Hafas.bind(_me.Controller.EventSearch.closeView,_me));
  Hafas.ps.sub('/GUI/restoreView/EventSearch', Hafas.bind(_me.Controller.EventSearch.restoreView,_me));
};
